import { MeasurementUnitDto } from "./measurement-unit.dto";

export class PackagingTypeDto {
    id?: number;
    externalId?: string;
    externalReference?: string;
    name!: string;
    quantityPerPackaging!: number;
    measurementUnit?: MeasurementUnitDto;
    measurementUnitId?: number;
    quantity?: number;
    batchNumberFormat?: string;
}
